import React from 'react';

import { Container, Main } from './styles';
import { Header, SideBar } from '../../../components';
import Content from './Content';
import { SiedeBarProvider } from '../../../hooks/sidebar';

const PrivateLayout: React.FC = ({ children }) => {
  return (
    <Container>
      <SiedeBarProvider>
        <Header />
        <Main>
          <SideBar />
          <Content>{children}</Content>
        </Main>
      </SiedeBarProvider>
    </Container>
  );
};

export default PrivateLayout;
